module.exports = __webpack_public_path__ + "media/images/common/h3_my_ranking-71defa2aad6e5811ff0de0d01b3acceb.png";